import { t } from "i18next";
import styled from "styled-components";
import Button from "../components/Button";
import Dialog from "../components/Dialog";
import DialogBody from "../components/DialogBody";
import DialogHeader from "../components/DialogHeader";

const Border = styled.div`
  border: ${(props) => props.theme.borders[4]};
  border-radius: ${(props) => props.theme.radii[3]};
`;

const UnsavedChangesDialogControls = styled.div`
  display: flex;
  gap: ${(props) => props.theme.space[4]};
`;

const UnsavedCopy = styled.div`
  padding: 0;
  color: ${(props) => props.theme.colors.white};
`;

const UnsavedChangesDialogCopy = styled.div`
  margin-bottom: ${(props) => props.theme.space[6]};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
`;

export interface IUnsavedChangesDialog {
  handleConfirm: () => void;
  handleHide: () => void;
  variant?: "unsavedChanges" | "reset";
}

const UnsavedChangesDialog = ({
  handleConfirm,
  handleHide,
  variant = "unsavedChanges",
}: IUnsavedChangesDialog) => {
  const copy = {
    unsavedChanges: {
      heading: t(
        "unsavedChangesDialog.heading.unsaved",
        "You have unsaved changes",
      ),
      body: t(
        "unsavedChangesDialog.body.unsaved",
        "Are you sure you want to leave this page?",
      ),
      confirm: t("unsavedChangesDialog.cta.affirmative", "Yes"),
      cancel: t("unsavedChangesDialog.cta.negative", "Cancel"),
    },
    reset: {
      heading: t("unsavedChangesDialog.heading.reset", "Reset Changes"),
      body: t(
        "unsavedChangesDialog.body.reset",
        "Are you sure you want to discard your changes? Your squad will return to its previous state.",
      ),
      confirm: t("unsavedChangesDialog.cta.resetChanges", "Reset Changes"),
      cancel: t("unsavedChangesDialog.cta.cancel", "Cancel"),
    },
  }[variant];

  return (
    <Dialog closeDialog={handleHide}>
      <Border>
        <DialogHeader closeDialog={handleHide}>
          <UnsavedCopy>{copy.heading}</UnsavedCopy>
        </DialogHeader>
        <DialogBody isPadded={true}>
          <UnsavedChangesDialogCopy>{copy.body}</UnsavedChangesDialogCopy>
          <UnsavedChangesDialogControls>
            <Button variant="primary" onClick={handleHide} width={1}>
              {copy.cancel}
            </Button>
            <Button variant="secondary" onClick={handleConfirm} width={1}>
              {copy.confirm}
            </Button>
          </UnsavedChangesDialogControls>
        </DialogBody>
      </Border>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
